export default {
  menuTitle: '菜单管理',
  userTitle: '用户管理',
  permissions: '权限',
  authorizationSuccessful: '授权成功',
  state: '状态',
  module: '模块',
  permissionButton: '权限按钮',
  age: '年龄',
  role: '角色',
  phone: '手机',
  email: '邮箱',
  rightsProfile: '权限配置',
  create: '创建',
  update: '更新',
  delete: '删除',
  detail: '详情',
  export: '导出',
  status: '状态',
  description: '描述',
  authorize: '授权',
};
